import * as types from './mutation-types'

export const callServer = ({ commit, dispatch, state },data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('call/server', data).then((response) => {
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}

export const loadTable = ({ commit, dispatch, state }, data) => {
    commit(types.LOAD_TABLE, data)
    commit(types.SAVE_TABLE_INFO)
}

export const resetTable = ({ commit, dispatch, state }) => {
    commit(types.RESET_TABLE)
}

export const saveTableInfo = ({ commit, dispatch, state }) => {
    commit(types.SAVE_TABLE_INFO)
}

